// Compartido entre Express y React. React Router reconoce rutas codificadas y
// no distingue mayusculas: la frontera de privacidad debe reconocerlas tambien.
function isPrivatePath(pathname) {
  if (typeof pathname !== 'string') return false;
  let decoded = pathname;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    try {
      const next = decodeURIComponent(decoded);
      if (next === decoded) break;
      decoded = next;
    } catch { break; }
  }
  const normalized = decoded.replace(/\\/g, '/').replace(/\/{2,}/g, '/').toLowerCase();
  return normalized === '/clientes' || normalized.startsWith('/clientes/');
}

module.exports = { isPrivatePath };
